import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge, taught the theme's own scales (src/styles/theme.css).
 *
 * Out of the box it only knows Tailwind's default names, so it read
 * `text-h3` / `text-caption` as a COLOUR and dropped it whenever a real colour
 * followed: `cn('text-h3', 'text-success-700')` came out as the colour alone,
 * and the figure fell back to whatever size its parent had. Keep these lists
 * in step with the `--text-*` and `--spacing-*` tokens in theme.css.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        'micro',
        'caption',
        'th',
        'small',
        'body',
        'body-lg',
        'h6',
        'h5',
        'h4',
        'h3',
        'h2',
        'h1',
        'display',
        // document scale (print sheets, tooth chart)
        'doc-2xs',
        'doc-xs',
        'doc-sm',
        'doc-md',
        'doc-lg',
        'doc-xl',
        'doc-2xl',
        'doc-3xl',
        'doc-4xl',
      ],
      spacing: ['touch', 'control', 'icon', 'icon-lg'],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
